import { FC } from "react"

interface Step {
  id: string
  name: string
  status: "complete" | "current" | "upcoming"
}

interface StepsProps {
  steps: Step[]
  onStepClick?: (stepId: string) => void
}

export const Steps: FC<StepsProps> = ({ steps, onStepClick }) => {
  return (
    <nav aria-label="Progress">
      <ol role="list" className="space-y-4 md:flex md:space-y-0 md:space-x-8">
        {steps.map((step) => (
          <li key={step.name} className="md:flex-1">
            {step.status === "complete" ? (
              <button
                type="button"
                onClick={() => onStepClick?.(step.id)}
                className="group border-primary-600 hover:border-primary-800 flex w-full items-center border-l-4 py-2 pl-4 text-left md:border-t-4 md:border-l-0 md:pt-4 md:pb-0 md:pl-0">
                <span className="text-primary-600 group-hover:text-primary-800 mr-2 text-sm font-medium">
                  {step.id}
                </span>
                <span className="text-sm font-medium">{step.name}</span>
              </button>
            ) : step.status === "current" ? (
              <button
                type="button"
                onClick={() => onStepClick?.(step.id)}
                aria-current="step"
                className="border-primary-600 flex w-full items-center border-l-4 py-2 pl-4 text-left md:border-t-4 md:border-l-0 md:pt-4 md:pb-0 md:pl-0">
                <span className="text-primary-600 mr-2 text-sm font-medium">{step.id}</span>
                <span className="text-sm font-medium">{step.name}</span>
              </button>
            ) : (
              <button
                type="button"
                onClick={() => onStepClick?.(step.id)}
                className="group flex w-full items-center border-l-4 border-gray-200 py-2 pl-4 text-left hover:border-gray-300 md:border-t-4 md:border-l-0 md:pt-4 md:pb-0 md:pl-0">
                <span className="mr-2 text-sm font-medium text-gray-500 group-hover:text-gray-700">
                  {step.id}
                </span>
                <span className="text-sm font-medium">{step.name}</span>
              </button>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
